/**
 * Editorial Item Animation Logic - Hybrid Architecture (Hover + Touch)
 */
document.addEventListener("DOMContentLoaded", () => {
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. Editorial Item animation skipped.");
		return;
	}

	const items = gsap.utils.toArray('.osmerova-editorial-item');
	if (items.length === 0) return;

	let mm = gsap.matchMedia();

	// ==========================================================
	// DESKTOP: Mouse Hover Logika (Nad 1150px)
	// ==========================================================
	mm.add("(min-width: 1151px)", () => {

		items.forEach((item) => {
			const title = item.querySelector('.item-left h3');
			const number = item.querySelector('.editorial-number');
			const desc = item.querySelector('.editorial-description');

			// Reset do počiatočného stavu
			gsap.set(desc, { y: "100%", opacity: 0, height: "auto", marginTop: 0 });
			gsap.set(title, { x: 0 });
			gsap.set(number, { y: "0%", opacity: 1, rotation: 0 });
			gsap.set(item, { opacity: 1 });

			const tl = gsap.timeline({
				paused: true,
				defaults: { duration: 0.6, ease: "expo.out" }
			});

			tl.to(number, { y: "-100%", opacity: 0 }, 0)
				.to(desc, { y: "0%", opacity: 1 }, 0)
				.to(title, { x: 8 }, 0);

			const playAnim = () => {
				tl.play();
				gsap.to(items.filter(i => i !== item), { opacity: 0.3, duration: 0.4 });
			};
			const reverseAnim = () => {
				tl.reverse();
				gsap.to(items, { opacity: 1, duration: 0.4 });
			};

			item.addEventListener('mouseenter', playAnim);
			item.addEventListener('mouseleave', reverseAnim);

			return () => {
				item.removeEventListener('mouseenter', playAnim);
				item.removeEventListener('mouseleave', reverseAnim);
			};
		});
	});

	// ==========================================================
	// MOBILE & TABLET: Touch Akordeón Logika (Do 1150px)
	// ==========================================================
	mm.add("(max-width: 1150px)", () => {
		let activeItem = null;

		items.forEach((item) => {
			const title = item.querySelector('.item-left h3');
			const number = item.querySelector('.editorial-number');
			const desc = item.querySelector('.editorial-description');

			// Reset do počiatočného stavu
			gsap.set(desc, { height: 0, opacity: 0, y: 0, marginTop: 0 });
			gsap.set(number, { y: 0, opacity: 1, rotation: 0 });
			gsap.set(title, { x: 0 });
			gsap.set(item, { opacity: 1 });

			item.animation = gsap.timeline({
				paused: true,
				defaults: { duration: 0.5, ease: "power2.inOut" }
			});

			// FIX: Už neanimujeme (neskrývame) číslo. Vysúva sa IBA popis nadol.
			item.animation
				.to(desc, { height: "auto", marginTop: "1rem", opacity: 1 }, 0);

			const toggleAccordion = () => {
				if (activeItem === item) {
					item.animation.reverse();
					gsap.to(items, { opacity: 1, duration: 0.4 });
					activeItem = null;
				} else {
					if (activeItem) {
						activeItem.animation.reverse();
					}
					item.animation.play();
					gsap.to(items.filter(i => i !== item), { opacity: 0.3, duration: 0.4 });
					gsap.to(item, { opacity: 1, duration: 0.4 });
					activeItem = item;
				}
			};

			item.addEventListener('click', toggleAccordion);

			return () => {
				item.removeEventListener('click', toggleAccordion);
				item.animation.kill();
			};
		});
	});
});
